import styled from 'styled-components';


export const Box = styled.div`
    display: inline-block;
    margin: 5px 15px 5px 5px;
    padding: 15px 5px 10px 0px;
    border: 1px solid #ccc;
    border-radius: 8px;
    width: 280px;

    h3 {
        color: #444;
        margin-bottom: 30px;
    }

    h4 {
        color: #444;
    }

    ul {
        display: flex;
        list-style-type: disc;
        list-style-position: inside;
        margin-left: 0px;
    }
        
    ul li {
        margin-left: 20px;
        width: 175px;
        overflow: hidden; 
        white-space: nowrap; 
        text-overflow: ellipsis;
        font-size: 13px;
    }

    ul span {
        margin-left: 10px;
    }

    p, li {
        font-size: 12px;
        color: #444;
        text-align: left;
    }    
`;

export const MetaBox = styled.div`
    display: inline-block;
    margin: 5px 15px 5px 5px;
    padding: 15px 5px 10px 0px;
    border: 1px solid #ccc;
    border-radius: 8px;
    width: 280px;
    background-color: steelblue;
    color: white;
    font-weight: 500;
`;